import { cn } from '@discover-lib/utils';

export type RootProps = React.ComponentPropsWithoutRef<'div'>;

export default function Root({ className, ...props }: RootProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-start justify-start gap-1 text-[14px] font-medium leading-[20px] text-ds-gray-light-700 md:flex-none md:flex-row md:flex-wrap md:items-center md:gap-2',
        className
      )}
      {...props}
    />
  );
}
